import tableAppBlackoutsPostalCodes from './tableAppBlackoutsPostalCodes';

export default {
  title: 'Postal Code Groups Blackouts',
  attributeName: 'postalCodes',
  createURL: 'blackoutsPostalCodes',
  getURL: 'blackoutsPostalCodes',
  updateURL: 'blackoutsPostalCodes',
  removeURL: 'blackoutsPostalCodes',
  sessionParams: ['appId'],
  idAttribute: 'id',
  autoUpdate:true,
  noArea: true,
  removeNameField:'name',
  removeText:'You are about to remove the Postal Group with name ##name##.',
  // tabs: [tabAppTransactions, tabAppFailedTransactions],
  tableConfig: tableAppBlackoutsPostalCodes,
  // initialTab: 'successful',
};
